module.exports = __webpack_public_path__ + "static/forecast/weather/daylightsnow-dec087d4a25732c7f98d9445a9e00407.svg";